// libraries
import React from "react";
import PropTypes from "prop-types";

// components
import CreatorInfo from "./CreatorInfo";

//styles
import colors from "core/colors";
import {
    ImageDetailHeroSectionContainer,
    ImageDetailGridContainer,
    LeftColGridItem,
    RightColGridItem,
    RightColumnInnerContainer
} from "./styles";

const ImageDetailHero = ({ leftColumnContent, rightColumnContent, image }) => {
    if (!image) return null;

    const { title, creator } = image;

    return (
        <ImageDetailHeroSectionContainer bgColor={colors.midnight}>
            <ImageDetailGridContainer
                justify="center"
                mobileMaxPadding={0}
                tabletMaxPadding={3}
                desktopMinPadding={3}
            >
                <LeftColGridItem item sm={12} md={8} lg={8}>
                    {leftColumnContent}
                </LeftColGridItem>
                <RightColGridItem item sm={12} md={4} lg={4}>
                    <RightColumnInnerContainer>
                        <CreatorInfo title={title} creator={creator} />
                        {rightColumnContent}
                    </RightColumnInnerContainer>
                </RightColGridItem>
            </ImageDetailGridContainer>
        </ImageDetailHeroSectionContainer>
    );
};

ImageDetailHero.propTypes = {
    leftColumnContent: PropTypes.element,
    rightColumnContent: PropTypes.element,
    image: PropTypes.object
};

export default ImageDetailHero;
